package ui.themePlusContext

import adapters.Storage
import react.*
import ru.malygin.myConst.SelectedCategory
import ui.styles.icons.DarkModeIconSVG
import ui.styles.icons.IconsSVG
import ui.styles.icons.LightModeIconSVG
import utils.logger.log
import web.dom.document


//
//     ОНО РАБОТАЕТ
//     (●'◡'●)
//


data class MyContextPR(
    var name: String? = null,
    var category: SelectedCategory = SelectedCategory.NONE,
    var setName: (String, SelectedCategory) -> Unit = {_,_ ->},
    var themeMode: ThemesMode = ThemesMode.LIGHT,
    var setThemeMode: (ThemesMode) -> Unit = { _ ->}
)

enum class ThemesMode(
    val key: String,
    val icon: IconsSVG
){
    LIGHT(
        key = "light",
        icon = LightModeIconSVG
    ),
    DARK(
        key = "dark",
        icon = DarkModeIconSVG
    )
}

val MyContext: Context<MyContextPR> = createContext(MyContextPR())


val MyContextModule = FC<PropsWithChildren>{
    val storage = Storage

    //name
    val stateName = useState(storage.getNameOrSet())
    val (name) = stateName

    //category
    val stateCategory = useState(storage.getCategoryOrSet())
    val (category) = stateCategory

    //theme
    var theme by useState(storage.getThemeOrSet())

    fun setThemeMode(
        newTheme: ThemesMode
    ){
        try {
            theme = newTheme
            storage.getThemeOrSet(newTheme)
            document.documentElement.setAttribute("data-theme", newTheme.key)
        }catch (_: Exception){}
    }
    useEffectOnce {
        setThemeMode(theme)
    }
    //theme--


    fun setName(
        name: String,
        category: SelectedCategory
    ){
        stateName.component2().invoke(name)
        stateCategory.component2().invoke(category)
        try {
            storage.getNameOrSet(name)
            storage.getCategoryOrSet(category)
        }catch (_: Exception){}
    }

    val mct = MyContextPR(
        name = name,
        category = category,
        themeMode = theme,
    )

    MyContext(mct){
        MyContext.Provider{
            this.value = mct
            this.value.setName = {name, category ->
                setName(
                    name = name,
                    category = category
                )
            }

            this.value.setThemeMode = {newTheme ->
                setThemeMode(newTheme)
            }

            +it.children
        }
    }
}

fun useMainContext() = useContext(MyContext)